/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * MQS measurement-symbol repair
 *
 * Some legacy/imported product text contains a literal question mark where an
 * inch mark or micron symbol should be shown, for example:
 *   Resolution: 0.005mm (0.0001?)
 *
 * This display-only repair is deliberately conservative:
 * - a question mark/replacement character after a numeric measurement is
 *   changed to a normal ASCII inch mark (") only in product-related content;
 * - ?m is changed to µm;
 * - common UTF-8 mojibake variants of inch and micron symbols are normalised;
 * - ordinary question marks in sentences are left untouched.
 */
(function mqsRepairMeasurementSymbols() {
  'use strict';

  var PRODUCT_CONTENT_SELECTOR = [
    '[data-section-type="product"]',
    '.mqs-tabs',
    '.mqs-alternatives',
    '.mqs-recommended-alternatives',
    '.product-item',
    '.search-bar__results',
    '.mini-cart',
    '.line-item'
  ].join(',');

  var PRODUCT_TITLE_SELECTOR = [
    '.product-meta__title',
    '.product-item__title',
    '.search-bar__item-title',
    '.line-item__title',
    '.mqs-alternative-card strong'
  ].join(',');

  var SKIPPED_TAGS = {
    SCRIPT: true,
    STYLE: true,
    NOSCRIPT: true,
    TEXTAREA: true,
    INPUT: true,
    SELECT: true,
    OPTION: true,
    CODE: true,
    PRE: true,
    IFRAME: true,
    SVG: true
  };

  // A decimal, whole number, simple fraction or numeric range.
  var measurementNumber = '((?:\\d+(?:[.,]\\d+)?|[.,]\\d+)(?:\\s*(?:[-–/]\\s*)(?:\\d+(?:[.,]\\d+)?|[.,]\\d+))?)';

  var badMicronBeforeM = new RegExp(measurementNumber + '\\s*[?�]\\s*m\\b', 'gi');
  var badInchBeforeBoundary = new RegExp(
    measurementNumber + '[?�](?=\\s*(?:[)\\],;:/\\\\.]|in(?:ch(?:es)?)?\\b))',
    'gi'
  );
  var badInchAtTextEnd = new RegExp(measurementNumber + '[?�]\\s*$', 'gi');
  var badInchInTitle = new RegExp(measurementNumber + '[?�](?=\\s|$|[)\\],;:/\\\\.-])', 'gi');
  var unicodeInchAfterNumber = new RegExp(measurementNumber + '[″”](?=\\s|$|[)\\],;:/\\\\.-])', 'g');
  var measurementContext = /\b(?:resolution|accuracy|graduation|range|inch|inches|imperial|measuring|measurement|diameter|length|width|height|depth|thickness|travel|stroke|parallelism|flatness|repeatability|reading|scale|division|increment|least count|capacity|span|tolerance)\b|\b(?:mm|µm|um)\b/i;

  function repairCommonEncoding(value) {
    return value
      // Common double-prime/curly-quote mojibake; use ASCII to avoid font issues.
      .replace(/â€³|â€œ|â€�|â€|â€/g, '"')
      // Common micro/mu mojibake and Greek mu; standardise to the micro sign.
      .replace(/Ã‚Âµ|Âµ|Î¼|μ/g, 'µ');
  }

  function repairProductText(value, titleMode) {
    var repaired = repairCommonEncoding(value);

    // Repair micron first so a value such as 0.05?m cannot be mistaken for inches.
    repaired = repaired.replace(badMicronBeforeM, '$1µm');
    repaired = repaired.replace(unicodeInchAfterNumber, '$1"');
    repaired = repaired.replace(badInchBeforeBoundary, '$1"');

    if (measurementContext.test(repaired)) {
      repaired = repaired.replace(badInchAtTextEnd, '$1"');
    }

    if (titleMode) {
      repaired = repaired.replace(badInchInTitle, '$1"');
    }

    return repaired;
  }

  function isProductTitleTextNode(textNode) {
    var parent = textNode.parentElement;
    return Boolean(parent && parent.closest(PRODUCT_TITLE_SELECTOR));
  }

  function repairTextNodes(root) {
    if (!root) {
      return;
    }

    if (root.nodeType === Node.TEXT_NODE) {
      var directParent = root.parentElement;
      if (!directParent || SKIPPED_TAGS[directParent.tagName]) {
        return;
      }

      var directOriginal = root.nodeValue;
      var directRepaired = repairProductText(directOriginal, isProductTitleTextNode(root));
      if (directRepaired !== directOriginal) {
        root.nodeValue = directRepaired;
      }
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    var element = root.nodeType === Node.ELEMENT_NODE ? root : null;
    if (element && SKIPPED_TAGS[element.tagName]) {
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function acceptNode(node) {
        var parent = node.parentElement;
        if (!parent || SKIPPED_TAGS[parent.tagName]) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNode;
    while ((textNode = walker.nextNode())) {
      var original = textNode.nodeValue;
      var repaired = repairProductText(original, isProductTitleTextNode(textNode));
      if (repaired !== original) {
        textNode.nodeValue = repaired;
      }
    }
  }

  function repairInitialPage() {
    var roots = document.querySelectorAll(PRODUCT_CONTENT_SELECTOR);
    for (var index = 0; index < roots.length; index += 1) {
      repairTextNodes(roots[index]);
    }
  }

  function repairAddedContent(node) {
    if (!node) {
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      var textParent = node.parentElement;
      if (textParent && textParent.closest(PRODUCT_CONTENT_SELECTOR)) {
        repairTextNodes(node);
      }
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    if (node.nodeType === Node.ELEMENT_NODE && node.matches(PRODUCT_CONTENT_SELECTOR)) {
      repairTextNodes(node);
      return;
    }

    if (node.querySelectorAll) {
      var nestedRoots = node.querySelectorAll(PRODUCT_CONTENT_SELECTOR);
      for (var index = 0; index < nestedRoots.length; index += 1) {
        repairTextNodes(nestedRoots[index]);
      }
    }
  }

  repairInitialPage();

  // Predictive search, quick-view and cart drawers are injected after page load.
  if (document.body && 'MutationObserver' in window) {
    var observer = new MutationObserver(function onMutations(mutations) {
      for (var mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
        var addedNodes = mutations[mutationIndex].addedNodes;
        for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
          repairAddedContent(addedNodes[nodeIndex]);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
